export default (restaurant, currentPath) => {
  let seoData;
  let ogType;
  const link = [];
  let appleAppId;
  let androidAppId;
  const isTemplateLight =
    restaurant &&
    restaurant.template &&
    restaurant.template.name === 'light';
  if (isTemplateLight) {
    link.push(
      {
        href: 'https://fonts.googleapis.com/css?family=Montserrat:400,700',
        rel: 'stylesheet',
        type: 'text/css'
      }, {
        href: 'https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,600',
        rel: 'stylesheet',
        type: 'text/css'
      }
    );
  }
  if (restaurant.template && restaurant.template.app && restaurant.template.app.iosUrl) {
    link.push({
      href: restaurant.template.app.icon,
      rel: 'apple-touch-icon'
    });
    link.push({
      href: restaurant.template.app.icon,
        rel: 'apple-touch-icon'
    });
    appleAppId = restaurant.template.app.iosUrl;
  }
  if (restaurant.template && restaurant.template.app && restaurant.template.app.androidUrl) {
    androidAppId = `com.foodit.restaurant.${restaurant.template.app.androidUrl}`;
  }

  // about ogType: http://ogp.me/#types
  switch (currentPath) {
    case '/menu':
      ogType = 'restaurant:menu';
      seoData = restaurant.seo.menu;
      break;
    case '/contact':
      ogType = 'restaurant:restaurant';
      seoData = restaurant.seo.contactUs;
      break;
    default:
      ogType = 'restaurant:restaurant';
      seoData = restaurant.seo.aboutUs;
  }

 // https://webcode.tools/open-graph-generator/restaurant
  const seoTitle = seoData && seoData.title || restaurant.name;
  const seoDescription = seoData && seoData.description ? `- ${seoData.description}` : '';
  const meta = [
    {charset: 'utf-8'},
    {name: 'description', content: seoDescription},
    {property: 'og:site_name', content: restaurant.name},
    {property: 'og:image', content: restaurant.imageLogoUrl},
    {property: 'og:locale', content: 'en_UK'},
    {property: 'og:title', content: seoTitle},
    {property: 'og:description', content: seoDescription},
    {property: 'og:card', content: 'summary'}, // Summary card -- Describe this 'page'
    {property: 'og:site', content: '@foodit'},
    {property: 'og:creator', content: '@foodit'},

    // Specific for Restaurant
    {property: 'og:type', content: ogType},
    {property: 'restaurant:menu', content: `${restaurant.domain}/menu`},
    {property: 'restaurant:contact_info:website', content: restaurant.domain},
    {
      property: 'restaurant:contact_info:street_address',
      content: `${restaurant.address.buildingNumber} ${restaurant.address.addressLine1}${restaurant.address.addressLine2 && ` ${restaurant.address.addressLine2}`}`
    },
    {property: 'restaurant:contact_info:locality', content: restaurant.address.city},
    {property: 'restaurant:contact_info:postal_code', content: restaurant.address.postcode},
    {property: 'restaurant:contact_info:country_name', content: restaurant.address.countryCode},
    {property: 'restaurant:contact_info:phone_number', content: restaurant.contactNumber},

    // Location
    {property: 'place:location:latitude', content: `${restaurant && restaurant.coordinates && restaurant.coordinates.latitude}`},
    {property: 'place:location:longitude', content: `${restaurant && restaurant.coordinates && restaurant.coordinates.longitude}`}
  ];

  if (appleAppId) {
    meta.push({name: 'restaurant-apple-itunes-app', content: `app-id=${appleAppId}`});
  }

  if (androidAppId) {
    meta.push({name: 'restaurant-google-play-app', content: `app-id=${androidAppId}`});
  }

  return {
    titleTemplate: `${restaurant.name} %s`,
    title: seoTitle,
    meta,
    link
  };
};



// WEBPACK FOOTER //
// ./helpers/seo.helper.js